/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
// Ember imports
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { service } from '@ember/service';

export default class SchoolDetails extends Component {
  // Services
  @service
  toaster;

  // Attributes
  // isDialogOpen indicates whether the enrolment dialog is open
  @tracked
  isDialogOpen = false;

  // school is the school for which this component is being rendered.
  school = null;

  // Computed attributes
  @computed('school.physicalAddress.[]')
  get schoolAddress1() {
    let buildingNumber = this.school.get('physicalAddress.number');
    let streetName = this.school.get('physicalAddress.street');
    let locality = this.school.get('physicalAddress.locality');

    let addressString = '';

    if (!isEmpty(buildingNumber)) {
      addressString += buildingNumber;
    }

    if (!isEmpty(streetName)) {
      if (!isEmpty(buildingNumber)) {
        // Format after the building number
        addressString += ' ';
      }
      addressString += streetName;
    }

    if (!isEmpty(locality)) {
      if (!isEmpty(addressString)) {
        // Format after the street name
        addressString += ', ';
      }
      addressString += locality;
    }

    return addressString;
  }

  @computed('school.{countryCode,physicalAddress.[]}')
  get schoolAddress2() {
    let countryName = this.school.get('countryName');

    let city = this.school.get('physicalAddress.district');

    let addressString = '';

    if (!isEmpty(city)) {
      addressString += city;
    }

    if (!isEmpty(countryName)) {
      if (!isEmpty(city)) {
        // Format after the city name
        addressString += ', ';
      }
      addressString += countryName;
    }

    return addressString;
  }

  @action
  openDialog() {
    this.isDialogOpen = true;
  }

  @action
  closeDialog() {
    this.isDialogOpen = false;
  }

  @action
  copyToClipboard(text) {
    navigator.clipboard.writeText(text).then(() => {
      this.toaster.success('Copied to clipboard');
    });
  }
}
